import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Admin portal layout with role-based access control.
 *
 * Uses the role from the Cognito ID token (stored in AuthContext) to gate access.
 * Only users with role === 'admin' see the admin navigation and child content.
 *
 * Requirement 15.1 — THE Portal SHALL provide an administrative interface
 * accessible only to Admin_Users.
 */

const AdminLayout: React.FC = () => {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="admin-loading" data-testid="admin-loading">
        <p>Loading admin portal…</p>
      </div>
    );
  }

  if (!user || user.role !== 'admin') {
    return (
      <div className="admin-access-denied" data-testid="admin-access-denied">
        <h1>Access Denied</h1>
        <p>You do not have permission to access the admin portal.</p>
      </div>
    );
  }

  return (
    <div className="admin-layout" data-testid="admin-layout">
      <nav className="admin-nav" data-testid="admin-nav">
        <h2>Admin Portal</h2>
        <ul>
          <li>
            <NavLink to="/admin/special-regulations" data-testid="admin-nav-special-regulations">
              Special Regulations
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/racing-rules" data-testid="admin-nav-racing-rules">
              Racing Rules of Sailing
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/irc-rules" data-testid="admin-nav-irc-rules">
              IRC Rules
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/orci-rules" data-testid="admin-nav-orci-rules">
              ORCi Rules
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/whatsapp" data-testid="admin-nav-whatsapp">
              WhatsApp
            </NavLink>
          </li>
        </ul>
      </nav>
      <div className="admin-content" data-testid="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
